export default __webpack_public_path__ + "static/media/createAccountPattern1.e8d46a01.png";